import axios from 'axios'
import swal from 'sweetalert2'
import { t } from '@transifex/native'

import { getProperty, getCollectionName } from '../utils'
import { swalError, swalSuccess, swalInfo, swalNotify } from '../components/Swaler'
// axios.defaults.baseURL = settings.hostname

if (!window.MYQLOCX_API) {
  window.MYQLOCX_API = 'http://localhost:3001/api'
}

const setAdmin = (data, query, dispatch) => {
  localStorage.userType = data.type // in case user is already logged in

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    userType: data.type,
    userId: data.user._id,
  })

  if (data.type === 'carrier') {
    dispatch(fetchData(['drivers', 'deliveries', 'events']))
  } else if (data.type === 'c_terminal' || data.type === 'subadmin') {
    dispatch(fetchData(['drivers', 'events', 'locks', 'deliveries']))
  } else if (data.type == 'admin') {
    dispatch(
      fetchData(
        ['locks', 'customers', 'events', 'easy_accesses', 'companies'],

        { events: { page: 0 } }
      )
    )
  }

  return {
    type: 'FETCH_ADMIN_SUCCESS',
    payload: data,
  }
}

const setCustomers = (data) => ({
  type: 'FETCH_CUSTOMERS_SUCCESS',
  payload: data,
})

const setCompanies = (data) => ({
  type: 'FETCH_COMPANIES_SUCCESS',
  payload: data,
})

const setRentalCompanies = (data) => ({
  type: 'FETCH_RENTAL_COMPANIES_SUCCESS',
  payload: data,
})

const setDrivers = (data) => ({
  type: 'FETCH_DRIVERS_SUCCESS',
  payload: data,
})

const setLocks = (data) => ({
  type: 'FETCH_LOCKS_SUCCESS',
  payload: data,
})

const setEasyAccesses = (data) => ({
  type: 'FETCH_EASYACCESSES_SUCCESS',
  payload: data,
})

const setTerminals = (data) => ({
  type: 'FETCH_C_TERMINALS_SUCCESS',
  payload: data,
})

const setVendors = (data) => ({
  type: 'FETCH_VENDORS_SUCCESS',
  payload: data,
})

const setSms = (data) => ({
  type: 'FETCH_S_SMS_SUCCESS',
  payload: data,
})

const setEvents = (data) => ({
  type: 'FETCH_EVENTS_SUCCESS',
  payload: data,
})

const setDeliveries = (data, query) => ({
  type: 'FETCH_DELIVERIES_SUCCESS',
  payload: data,
  query,
})

const setCarriers = (data) => ({
  type: 'FETCH_CARRIERS_SUCCESS',
  payload: data,
})

const setControllers = (data) => ({
  type: 'FETCH_CONTROLLERS_SUCCESS',
  payload: data,
})

export function deleteData(collectionName, id) {
  const entity_name = collectionName
    .split('')
    .slice(0, collectionName.length - 1)
    .join('')

  return (dispatch) => {
    dispatch({ type: `DELETING_${entity_name.toUpperCase()}` })
    dispatch({ type: 'LOADING' })
    return axios
      .delete(`${window.MYQLOCX_API}/${collectionName}/${id}`)
      .then((res) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: `DELETE_${entity_name.toUpperCase()}_FINISHED`,
          payload: res.data,
        })
        return res.data
      })
      .catch((err) => console.log('ERROR:', err.response))
  }
}

export function createData(collectionName, obj) {
  const entity_name = collectionName
    .split('')
    .slice(0, collectionName.length - 1)
    .join('')
    .toUpperCase()
  return (dispatch) => {
    dispatch({ type: `CREATING_${entity_name}` })
    dispatch({ type: 'LOADING' })
    return axios
      .post(`${window.MYQLOCX_API}/${collectionName}`, obj)
      .then((res) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: `CREATING_${entity_name}_FINISHED`,
          payload: res.data,
        })
        return res
      })
      .catch((err) => {
        console.log('ERROR:', err.response)
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({ type: `CREATING_${entity_name}_ERROR`, payload: err.response.data.message })
        return err
      })
  }
}

export function createDeliveries(deliveries) {
  return (dispatch) => {
    dispatch({ type: 'CREATE_DELIVERY_REQUEST' })
    return axios
      .post(`${window.MYQLOCX_API}/subject/admin/bi/createdeliveries`, deliveries)
      .then((r) => {
        dispatch({ type: 'DELIVERY_CREATED' })
        return r
      })
      .catch(() => dispatch({ type: 'DELIVERY_CREATED_FAIL' }))
  }
}

export function submitData(entity, id, obj, disable_swal) {
  const property = getProperty(entity, Object.keys(obj)[0])
  console.log(obj)
  switch (property.type) {
    case 'number':
      obj[Object.keys(obj)[0]] = parseInt(obj[Object.keys(obj)[0]])
      break
  }

  const collectionName = getCollectionName(entity)

  return (dispatch) => {
    dispatch({ type: `SUBMITTING_${entity.toUpperCase()}` })
    dispatch({ type: 'LOADING' })
    axios
      .put(`${window.MYQLOCX_API}/${collectionName}/${id}`, obj)
      .then((res) => {
        dispatch({ type: 'LOADING_FINISHED' })
        console.log(disable_swal)
        if (!disable_swal) {
          dispatch({ type: 'FEEDBACK_SUCCESS' })
        }

        if (entity === 'admin') {
          swal.fire({
            position: 'top-right',
            type: 'success',
            title: 'Sparat',
            showConfirmButton: false,
            timer: 1500,
          })
        }

        dispatch({
          type: `SUBMIT_${entity.toUpperCase()}_SUCCESSFUL`,
          payload: res.data,
          dispatch,
        })
      })
      .catch((err) => console.log(err, 'ERROR:', err.response))
  }
}

export function submitLocksAndUsers(obj, cb) {
  return (dispatch) => {
    dispatch({ type: 'LOADING' })
    axios
      .post(`${window.MYQLOCX_API}/subject/admin/users`, obj)
      .then((res) => {
        swalSuccess(t('Saved'), '', null, '', 1500)
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: 'SUBMIT_LOCKSANDUSERS_SUCCESS',
          payload: res.data,
        })
        cb(null, {})
      })
      .catch((error) => {
        cb(error)
        dispatch({ type: 'LOADING_FINISHED' })

        if (error.response?.data?.suppliers) return

        // Handle errors, including HTTP response codes 500 and others
        if (error.response) {
          // The request was made and the server responded with a status code
          swalError('Oops!', error.response.status, error.response.data)
        } else if (error.request) {
          // The request was made but no response was received
          swalError('Oops!', error.request)
        } else {
          // Something happened in setting up the request that triggered an error
          swalError('Oops!', error.message)
        }
      })
  }
}
export function removeLockAccesses(accessIds) {
  const query = `id=${accessIds.join('&id=')}`

  return (dispatch) => {
    dispatch({ type: 'LOADING' })
    axios
      .delete(`${window.MYQLOCX_API}/subject/admin/users?${query}`)
      .then((res) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: 'REMOVE_LOCK_ACCESSES_SUCCESS',
          payload: accessIds,
        })
      })
      .catch((err) => console.log(err, 'ERROR:', err.response))
  }
}

export function fetchDocument(id, collection_type, lock_id) {
  console.log(id)
  return (dispatch) => {
    dispatch({ type: 'LOADING' })
    axios.get(`${window.MYQLOCX_API}/${collection_type}/${id}`).then((res) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({
        type: 'FETCH_ALLOCATION_DELIVERY_SUCCESS',
        payload: res.data,
      })
    })
  }
}

export function createEasyAccess(...params) {
  console.log(params)
  return (dispatch) => {
    dispatch({ type: 'LOADING' })
    axios({
      method: 'post',
      url: `${window.MYQLOCX_API}/easy_accesses?lock=${params[0]}`,
      data: {
        target: params[1],
        unlimited_uses: params[2],
        timeframe: params[3],
      },
    })
      .then((res) => {
        console.log(res.data)
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: 'SUBMIT_EASYACCESS_SUCCESS',
          payload: res.data,
        })
        swalSuccess('Framgång!', null, 'OK', `En gästnyckel till ${params[1]} har skickats.`)
      })
      .catch((e) => {
        if (!e.response) return
        if (e.response.status == 401) {
          swalError('', 'Vänligten logga in igen').then((t) => {
            window.location.href = `${window.location.origin}${window.BASE_NAME}login`
          })
        } else {
          console.log(e.response)
          const text = e.response.data
          swalError('', text)
        }
      })
  }
}

export const inactivateEasyAccesses = (ids) => (dispatch) =>
  new Promise((resolve) => {
    axios
      .delete(`${window.MYQLOCX_API}/subject/admin/easy_accesses/${ids.join(',')}`)
      .then((res) => {
        console.log(res)
        dispatch({
          type: 'INACTIVATE_EASYACCESSES_SUCCESS',
          payload: ids,
        })

        resolve(res.data)
      })
      .catch((err) => {
        console.log(err)
      })
  })

const funcDict = {
  admin: setAdmin,
  locks: setLocks,
  companies: setCompanies,
  rental_companies: setRentalCompanies,
  customers: setCustomers,
  drivers: setDrivers,
  carriers: setCarriers,
  events: setEvents,
  deliveries: setDeliveries,
  controllers: setControllers,
  easy_accesses: setEasyAccesses,
  c_terminals: setTerminals,
  vendors: setVendors,
  s_sms: setSms,
}

export const fetchDocuments = (collection, ids) => (dispatch) => {
  const { userType } = window.localStorage

  dispatch({ type: `FETCH_${collection.toUpperCase()}` })
  dispatch({ type: 'LOADING' })

  const url = `${window.MYQLOCX_API}/subject/${userType}/${collection}/documents?id=${ids.join('&id=')}`
  return axios
    .get(url)
    .then((t) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({ type: `FETCH_${collection.toUpperCase()}_DOCUMENTS_SUCCESS`, payload: t.data })
    })
    .catch((e) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({ type: 'FETCH_DATA_ERROR', errorMessage: e.message || e.response?.data?.message })

      if (e.response && e.response.data && e.response.data.message == 'Unrecognized token') {
        window.localStorage.removeItem('token')
        window.localStorage.removeItem('userType')
        window.location.href = `${window.location.origin}${window.BASE_NAME}login`
      }
    })
}

export const fetchData = (params, options = {}) => async (dispatch) => {
  if (!params || !params.length) return console.log('saknar params i fetchData')

  const { userType } = window.localStorage
  if (!userType || !window.localStorage.getItem('token') || window.localStorage.getItem('token') == 'null') return (window.location.href = `${window.location.origin}${window.BASE_NAME}login`)

  params.forEach((param) => {
    let querystring = '?'

    if (options[param]) {
      const opt = options[param]
      Object.entries(opt).forEach((pair) => {
        querystring += `${pair[0]}=${pair[1]}&`
      })
    }

    dispatch({ type: `FETCH_${param.toUpperCase()}` })
    dispatch({ type: 'LOADING' })
    const url = `${window.MYQLOCX_API}/subject/${userType}/${param}${querystring}`
    axios
      .get(url)
      .then((t) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch(funcDict[param](t.data, options[param], dispatch))
      })
      .catch((e) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({ type: 'FETCH_DATA_ERROR', errorMessage: e.message || e.response?.data?.message })
        if (e.response && e.response.data && e.response.data.message == 'Unrecognized token') {
          console.log(window.localStorage)
          window.localStorage.removeItem('token')
          window.localStorage.removeItem('userType')
          window.location.href = `${window.location.origin}${window.BASE_NAME}login`
        }
      })
  })
}

export const fetchCollection = (collectionName, query) => {
  const { userType } = window.localStorage
  if (!userType || !window.localStorage.getItem('token') || window.localStorage.getItem('token') == 'null') return (window.location.href = `${window.location.origin}${window.BASE_NAME}login`)

  let url = `${window.MYQLOCX_API}/subject/${userType}/${collectionName}`

  if (query) {
    url += '?'
    Object.entries(query).forEach(([key, val]) => {
      url += `${key}=${val}&`
    })
  }

  return (dispatch) => {
    dispatch({ type: 'LOADING' })
    axios
      .get(url)
      .then((t) => {
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({
          type: `FETCH_${collectionName.toUpperCase()}_SUCCESS`,
          payload: t.data,
          query,
        })
      })
      .catch((e) => console.log(e))
  }
}

export const createStorage = (obj) => {
  const url = `${window.MYQLOCX_API}/subject/admin/storages`
  return axios
    .post(url, obj)
    .then((r) => {
      swalSuccess('Sparat', 'Ditt förråd har blivit registrerat!', 'Tack!', null)
      return r
    })
    .catch((e) => {
      swalError(e.response.data.message)
    })
}

export const createLock = (obj) => {
  const url = `${window.MYQLOCX_API}/subject/admin/locks`
  return () =>
    axios
      .post(url, obj)
      .then((t) => {
        swalSuccess('Sparat', 'Dina enheter har blivit registrerade!', 'Tack!', null)
        return t
      })
      .catch((e) => {
        swalError(e.response.data.message)
      })
}

export const createCluster = (obj, cb) => {
  const url = `${window.MYQLOCX_API}/subject/admin/locks/cluster`
  return () =>
    axios
      .post(url, obj)
      .then((t) => {
        swalSuccess('Sparat', 'Ditt kluster har blivit registrerat!', 'Tack!', null)
        cb()
        return t
      })
      .catch((e) => {
        if (e.response) swalError(e.response.data.message)
      })
}

export const updateDBF = (lockId, carrierId, action) => {
  const url = `${window.MYQLOCX_API}/dbf/${lockId}/${carrierId}/${action}`
  return (dispatch) => {
    axios
      .post(url)
      .then((t) => {
        console.log(t.data)
        dispatch({
          type: 'DBF_SUCCESS',
          payload: { data: t.data, lockId },
        })
        swalInfo('Sparat', null, 'Inställning sparad!')
      })
      .catch((e) => {
        console.log(e.response)
        swalError(e.response.data.message)
      })
  }
}

export const createVendor = (obj) => async (dispatch) => {
  dispatch({ type: 'LOADING' })
  return axios
    .post(`${window.MYQLOCX_API}/subject/admin/vendors`, obj)
    .then((r) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({ type: 'CREATING_VENDOR_FINISHED', payload: r.data })
      return r.data
    })
    .catch((err) => {
      console.log(err)
      dispatch({ type: 'LOADING_FINISHED' })
      throw err
    })
}

export const updateVendor = (obj) => async (dispatch) => {
  dispatch({ type: 'LOADING' })
  return axios
    .put(`${window.MYQLOCX_API}/subject/admin/vendors/${obj._id}`, obj)
    .then((r) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({ type: 'UPDATE_VENDOR_FINISHED', payload: r.data })
      return r.data
    })
    .catch((err) => {
      console.log(err)
      dispatch({ type: 'LOADING_FINISHED' })
      throw err
    })
}

export const deleteVendor = (id) => async (dispatch) => {
  dispatch({ type: 'LOADING' })
  return axios
    .delete(`${window.MYQLOCX_API}/subject/admin/vendors/${id}`)
    .then((r) => {
      dispatch({ type: 'LOADING_FINISHED' })
      dispatch({ type: 'REMOVE_VENDOR_FINISHED', payload: id })
    })
    .catch((err) => {
      console.log(err)
      dispatch({ type: 'LOADING_FINISHED' })
    })
}

export const sendEasyAccesses = (receivers, lockId, additionalInfo) => (dispatch) => {
  dispatch({ type: 'LOADING' })

  return new Promise((resolve) => {
    axios
      .post(`${window.MYQLOCX_API}/subject/admin/easy_accesses/receiverlist/lock`, { lockId, receivers, additionalInfo })
      .then((r) => {
        resolve(r.data)
        console.log(r.data)
        dispatch({ type: 'LOADING_FINISHED' })
        dispatch({ type: 'CREATING_EASYACCESSES_WITH_RECEIVERLIST_FINISHED', payload: r.data })
      })
      .catch((err) => {
        console.log(err)
        dispatch({ type: 'LOADING_FINISHED' })
      })
  })
}

export const deactivateContainer = (lockId) => async (dispatch) =>
  axios.put(`${window.MYQLOCX_API}/subject/${window.localStorage.userType}/locks/${lockId}/deactivate`, {}).then(() => {
    dispatch({
      type: 'LOCK_DEACTIVATED',
      payload: { lockId },
    })

    swal.fire({
      html: 'Lås borttaget',
      type: 'success',
      timer: 1500,
      showConfirmButton: false,
    })
  })

export const saveCarrierMappings = (vendorId, carrierMappings) => (dispatch) =>
  axios.put(`${window.MYQLOCX_API}/subject/admin/vendors/${vendorId}/carriermappings`, carrierMappings).then((r) => {
    dispatch({ type: 'SET_CARRIERMAPPINGS_FINISHED', payload: r.data })
    return r
  })

export const mergeVendors = (vendorId, originalVendorId, tags) => (dispatch) =>
  axios.put(`${window.MYQLOCX_API}/subject/admin/vendors/${vendorId}/merge`, { originalVendorId }).then((r) => {
    dispatch({ type: 'SET_MERGEVENDORS_FINISHED', payload: { vendorId, originalVendorId, tags } })
    return r
  })

const pluralizeEntityName = {
  company: 'companies',
}

export const createEntity = (entityName, obj) => (dispatch) => {
  const entityNamePluralized = pluralizeEntityName[entityName]
  return axios.post(`${window.MYQLOCX_API}/subject/admin/${entityNamePluralized}`, obj).then((r) => {
    dispatch({ type: `CREATE_${entityName.toUpperCase()}_FINISHED`, payload: { data: r.data, obj } })
    return r
  })
}
